<!-- 单选 -->
<template>
  <div>
    <el-dialog :before-close="handleClose" title="选择人群" custom-class="select-people-dialog"
      :visible.sync="selectPeopleDialog" width="1050px">
      <div slot="title" class="dialog-title">
        <span>选择人群</span>
      </div>
      <div>
        <el-form :inline="true" :model="crowdParams" label-width="70px"
          style="display:flex;justify-content:space-between;margin-bottom:20px;align-items: center;">
          <div>
            <el-form-item label="人群名称" style="margin-bottom:0">
              <el-input v-model="crowdParams.name" placeholder="人群名称/人群描述"></el-input>
            </el-form-item>
            <el-form-item label="人群类型" style="margin-bottom:0">
              <el-select v-model="crowdParams.type" placeholder="请选择" @change="handleChangeType">
                <el-option label="全部" value=""></el-option>
                <el-option label="系统人群" :value="0"></el-option>
                <el-option label="自定义人群" :value="1"></el-option>
                <el-option label="数坊人群" :value="7"></el-option>
                <el-option label="上传人群" :value="8"></el-option>
                <el-option label="二次营销" :value="14"></el-option>
                <el-option label="官方推荐人群" :value="9"></el-option>
                <el-option label="行业专属人群" :value="10"></el-option>
                <el-option label="定制人群" :value="11"></el-option>
                <el-option label="运算人群" :value="12"></el-option>
                <el-option label="互动人群" :value="13"></el-option>
              </el-select>
              <el-select v-model="crowdParams.classifyId" v-if="searchCrowdType == 1 " style="margin-left: 8px;width:150px">
                <el-option value="" label="全部"></el-option>
                <el-option
                  v-for="(item, index) in classPeopleList"
                  :key="index"
                  :value="item.classifyId"
                  :label="item.name"
                >
                  {{ item.name }}
                </el-option>
              </el-select>
              <el-select v-model="crowdParams.classifyId" v-else-if="searchCrowdType == 2" style="margin-left: 8px;width:150px">
                <el-option value="" label="全部"></el-option>
                <el-option :value="0" label="默认分组"></el-option>
                <el-option
                  v-for="(item, index) in classPeopleList"
                  :key="index"
                  :value="item.classifyId"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <div class="button-group">
              <el-button size="small" class="search" @click="submitForm()">
                <i class="el-icon-search" style="display: inline-block; width: 14px; height: 12px"></i>
                查询
              </el-button>
              <el-button size="small" class="reset" @click="resetForm">重置</el-button>
            </div>
          </div>
          <div class="btn_create" @click="toCreatePeople">
            <img :src="btnImg" alt="" style="width:26px;margin-right:-2px" class="" />
            <span>去创建人群</span>
          </div>
          <!-- <el-button type="primary" @click="toCreatePeople" class="btn_create">去创建人群</el-button> -->
        </el-form>
        <div class="table-box">
          <el-table ref="multipleTable" tooltip-effect="light" :data="crowdTableData"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }"
            style="width: 100%; border: 1px solid #eee" stripe
            v-loading="tableLoading">
            <template slot="empty">
              <div style="margin: 20px">
                <img :src="nodata" style="
                        display: inline-block;
                        vertical-align: middle;
                        cursor: pointer;
                      " />
                <span class="nodata1">暂无数据</span>
              </div>
            </template>
            <!-- <el-table-column type="selection" width="55" :selectable="checkboxT"></el-table-column> -->
            <el-table-column label="选择" width="55px">
              <template slot-scope="scope">
                <el-radio style="margin-left: 10px;" :label="scope.row" v-model="tabRadio"
                  @change="handleSelectionChange(scope.row)" :disabled="scope.row.count <= 0">{{ "" }}</el-radio>
              </template>
            </el-table-column>
            <el-table-column label="人群名称" prop="name"></el-table-column>
            <el-table-column label="人群人数" prop="count">
              <template slot-scope="scope">
                <span v-if="scope.row.type==14">
                  {{ scope.row.count==null ? "0（生成中...）" : scope.row.count }}
                </span>
                <span v-else>{{ scope.row.count }}</span>
              </template>
            </el-table-column>
            <el-table-column label="人群类型">
              <template slot-scope="scope">
                {{ scope.row.type | showType }}
              </template>
            </el-table-column>
            <el-table-column label="人群描述" prop="description">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.description" placement="top">
                  <el-button class="buttom_tooltip">{{ scope.row.description }}</el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.createTime }}</span>
              </template>
            </el-table-column>
            <!-- 2期 -->
            <el-table-column label="" prop="createTime" width="250px">
              <template slot-scope="scope" v-if="scope.row.isAdvanced">
                <div>
                  <span>高级版专属人群</span>&nbsp;&nbsp;
                  <span style="color:#fe4d45;cursor:pointer" @click="upgrade">点击升级>></span>
                </div>
              </template>
            </el-table-column>
            <!-- end -->
          </el-table>
        </div>
        <!-- 分页器 -->
        <div class="block">
          <el-pagination background style="text-align: right; margin-top: 20px" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="crowdParams.current"
            :page-sizes="[10, 20, 30, 50, 100, 500, 1000]" :page-size="crowdParams.size"
            layout="total, sizes, prev, pager, next, jumper" :total="crowdTotal"></el-pagination>
        </div>
        <!-- 底部按钮 -->
        <div class="dialog-footer-btn">
          <el-button class="reset" @click="handleClose">取消</el-button>
          <el-button class="search" @click="handleConfirm">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMemberCrowd } from "@/api/marketing/memberCrowd";
import { queryCrowdClassify } from "@/api/manage/memberCrowdController";
import { mapState } from "vuex";

export default {
  /*  选择人群弹窗 */
  name: "select-people",
  props: {
    selectPeopleDialog: {
      type: Boolean,
      default: false,
    },
    peopleList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      classPeopleList: [],
      nodata: require("@/assets/images/nodata.png"),
      btnImg: require("@/assets/images/btn_添加.svg"),
      jumpUrl: "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=myarticle",
      crowdTableData: [],
      tableLoading: false,
      crowdParams: {
        current: 1,
        size: 10,
        name: "",
        type: "",
        classifyId:'',
      },
      crowdTotal: 0,
      selectList: [],
      addGroup: [], // 当前页勾选的数据
      val: "",
      tabRadio: {}
    };
  },
  computed: {
    // 0 没有二级分类 1 有二级分类 2 有二级分类且可编辑/删除
    searchCrowdType(){
      if(this.crowdParams.type == 1 || this.crowdParams.type == 12 || this.crowdParams.type == 13){
        return 2
      }else if(this.crowdParams.type === 0 || this.crowdParams.type == 10 || this.crowdParams.type == 11 || this.crowdParams.type == 8){
        return 1
      }else{
        return 0
      }
    }
  },
  destroyed() {
    // window.removeEventListener("storage");
  },
  mounted() {
    console.log(this.peopleList);
    this.selectList = this.peopleList;
    this.getPeopleData();
    // 监听LocalStorage变化
    window.addEventListener("storage", (e) => {
      console.log(e);
      if (this.val != e.newValue) {
        this.getPeopleData();
      }
      this.val = e.newValue;
    });
  },

  methods: {
    // 跳转到服务市场
    upgrade() {
      window.open(this.jumpUrl, "_blank");
    },
    // 将回传的列表数据显示为已勾选
    checkboxT(row, index) {
      if (row.count > 0) {
        return 1;
      } else {
        return 0;
      }
    },
    toCreatePeople() {
      let routeUrl = this.$router.resolve({
        path: "/marketing/marketing/grouping?create=1",
      });
      window.open(routeUrl.href, "_blank");
    },
    showPeopleCheck() {
      this.$nextTick(() => {
        var selectList = this.selectList;
        this.tabRadio = {}
        this.crowdTableData.forEach((row) => {
          for (var i = 0; i < selectList.length; i++) {
            if (row.precisionCrowdStrategyId == selectList[i].precisionCrowdStrategyId) {
              this.tabRadio = row
              break;
            }
          }
        });
      });
    },

    handleConfirm() {
      this.computedSelectPeople();
      this.$emit("onConfirm", this.selectList);
    },
    // 勾选内容
    handleSelectionChange(list) {
      // 当前列表页勾选的数据
      this.selectList = [list];
    },

    // 勾选，取消人群计算
    computedSelectPeople() {
      // 当前列表页勾选的数据
      var addGroup = this.selectList;
      // 当前列表未勾选的数据
      var delGroup = [];
      this.crowdTableData.forEach((item) => {
        var flag = false;
        addGroup.forEach((selectItem) => {
          if (item.precisionCrowdStrategyId == selectItem.precisionCrowdStrategyId) {
            flag = true;
          }
        });
        if (!flag) {
          delGroup.push(item);
        }
      });
      console.log("delGroup", this.delGroup);

      // 添加数据
      var groupDataList = JSON.parse(JSON.stringify(this.selectList));
      addGroup.forEach(function (addItem) {
        var flag = false; // 是否添加该数据
        groupDataList.forEach(function (groupItem) {
          if (addItem.precisionCrowdStrategyId == groupItem.precisionCrowdStrategyId) {
            flag = true;
          }
        });
        if (!flag) {
          groupDataList.push(addItem);
        }
      });
      console.log("添加之后的", groupDataList);

      // 删除重复数据
      groupDataList = groupDataList.filter(function (groupItem) {
        var flag = true;
        delGroup.forEach(function (delItem) {
          if (delItem.precisionCrowdStrategyId == groupItem.precisionCrowdStrategyId) {
            flag = false;
          }
        });
        return flag;
      });

      console.log("groupDataList", groupDataList);
      this.selectList = groupDataList;
    },

    // 查询人群接口
    submitForm() {
      this.getPeopleData();
    },
    // 重置接口
    resetForm() {
      this.crowdParams = {
        current: 1,
        size: 10,
        name: "",
        type: "",
      };
      this.getPeopleData();
    },

    // 获取人群选择列表
    getPeopleData() {
      this.computedSelectPeople();
      this.tableLoading = true;
      getMemberCrowd({ ...this.crowdParams, description: this.crowdParams.name }).then((res) => {
        this.tableLoading = false;
        this.crowdTableData = res.data.records;
        this.crowdTotal = +res.data.total;
        this.showPeopleCheck();
      });
    },
    handleSizeChange(val) {
      this.crowdParams.size = val;
      this.getPeopleData();
    },
    handleCurrentChange(val) {
      this.crowdParams.current = val;
      this.getPeopleData();
    },
    handleClose() {
      this.$emit("onCancle");
    },
    handleChangeType(){
      this.crowdParams.classifyId = ''
      if(this.searchCrowdType){
        queryCrowdClassify(this.crowdParams.type).then(res=>{
          
          this.classPeopleList = res.data
        })
      }
    },
  },
  filters: {
    showType: function (val) {
      var result = "";
      if (val == "1") {
        result = "自定义分组";
      } else if (val == "2") {
        result = "筛选条件人群包";
      } else if (val == "0") {
        result = "系统分组";
      } else if (val == "7") {
        result = "数访人群";
      } else if (val == "8") {
        result = "上传人群";
      } else if (val == "9") {
        result = "官方推荐人群";
      } else if (val == "10") {
        result = "行业专属人群";
      } else if (val == "11") {
        result = "定制人群";
      }else if (val == "12") {
        result = "运算人群";
      } else if (val == "13") {
        result = "互动人群";
      } else if (val == "14") {
        result = "二次营销";
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.buttom_tooltip {
  border: none;
  background-color: transparent;
  text-align: left;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  &:hover {
    background-color: transparent;
    color: #666;
  }
}

/deep/ .el-table__body-wrapper {
  height: 345px;
  overflow-y: auto;
}

// 选择人群弹窗
.select-people-dialog {
  .table-box {
    max-height: 400px;
    overflow: auto;
  }

  .dialog-title {
    span {
      color: #333;
      font-size: 16px;
      font-weight: bold;
      margin-right: 20px;

      .el-button {
        font-size: 14px;
      }
    }
  }

  .search-line {
    margin-bottom: 24px;

    .el-input {
      width: 280px;
      margin-right: 20px;
    }
  }

  .button-group {
    display: inline-block;

    .search {
      width: 98px;
      height: 32px;
      color: #fe4d45;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fff;

      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }

      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }

    .reset {
      width: 98px;
      height: 32px;
      color: #666666;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #dddddd;

      background-color: #fff;

      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }

      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }

  .dialog-footer-btn {
    text-align: right;
    margin-top: 30px;

    .search {
      width: 98px;
      height: 32px;
      color: #ffffff;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;

      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }

      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }

    .reset {
      width: 98px;
      height: 32px;
      color: #666666;
      font-size: 14px;
      // margin: 0px 0px 0 800px;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;

      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }

      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }

  .btn_create {
    color: #7f85e9;
    float: right;
    width: 98px;
    height: 28px;
    display: flex;
    align-items: center;
    // line-height: 28px;
    font-size: 14px;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>
